import { EngineError } from '../../../../../cms/fields/types/checkout-page'
import { useCheckoutDebugParameter } from '../../../domain/hooks'
import { CheckoutError } from '../../../domain/types'
import { TypeOfErrors } from './constants'

export function useCustomerErrorMessage(error: CheckoutError | undefined, engineErrorConfig: EngineError | null): string {
  const isDebug = useCheckoutDebugParameter()
  let message = ''

  if (isDebug) {
    message = (error && error.message) ? error.message : ''
  }
  else if (error?.typeOfError === TypeOfErrors.MaxInsurancePriceExceeded) {
    message = engineErrorConfig?.ErrorMessageWhenInsuranceExceeded ?? ''
  }
  else if (error?.typeOfError === TypeOfErrors.ExternalFlightsError) {
    message = engineErrorConfig?.ErrorMessageWithExternalFlight ?? ''
  }

  return engineErrorConfig?.TextError?.replace('{ERROR_MESSAGE}', message || '') ?? ''
}
